import React from "react";
import PropTypes from "prop-types";
import { loadCSS } from "fg-loadcss/src/loadCSS";
import classNames from "classnames";
import MapContainer from "../Components/MapContainer/MapWrapper";
import { withStyles } from "@material-ui/core/styles";

import moment from "moment";

import FolderIcon from "@material-ui/icons/Folder";

import {
    Card,
    CardHeader,
    CardMedia,
    CardContent,
    Avatar,
    ListItemAvatar,
    Fade,
    Select,
    MenuItem,
    TextField,
    InputLabel,
    Icon,
    CircularProgress,
    Typography,
    FormControl,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Geocode from "react-geocode";
import { connect } from "react-redux";
import { AccountBox } from "@material-ui/icons";
import {
    getJobPack,
    removeJobPack,
    setSelectedJobPackIndex,
    setSelectedTab,
    postEditedJobPack,
    getReportTitles,
    setUploadedFiles,
    gotolink,
    getAllUsers,
    uploadFile,
    removeFile
} from "./actions";
import {
    selectJobPack,
    selectAllUsers,
    selectUploadedFiles,
    selectReportTitles
} from "./selectors";
import labels from "./labels.json";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableRow from "@material-ui/core/TableRow";
// import Grid from "@material-ui/core/Grid";

const styles = theme => ({
    "*": {
        transition: ".3s ease-in-out"
    },
    avatar: {
        margin: 10,
        padding: 10,
        backgroundColor: "rgb(63,81,181)"
    },
    bigAvatar: {
        width: "50%",
        height: "auto",
        display: "block",
        margin: "0 auto",
        position: "relative"
    },

    actions: {
        display: "flex"
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        marginLeft: "auto"
    },
    icon: {
        width: "auto",
        color: "inherit"
    },
    card: {
        fontSize: 18,
        maxWidth: 345
    },
    media: {
        height: 0,
        paddingTop: "56.25%" // 16:9
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },

    button: {
        margin: 10
    },
    textField: {
        margin: 20,
        width: "75%"
    },
    form: {
        margin: 20,
        width: "75%"
    },
    picker: {
        fontSize: "12px"
    },
    paper: {
        padding: 12
    },
    tabTitle: {
        width: "100%",
        boxShadow: "none"
    },
    tabText: {
        color: "white"
    },
    bgGreen: {
        backgroundColor: "green"
    },
    bgAmber: {
        backgroundColor: "orange"
    },
    bgRed: {
        backgroundColor: "red"
    },
    activeTab: {
        backgroundColor: "rgb(63,81,181)",
        borderRadius: 8,
        color: "white",
        "&:hover": {
            backgroundColor: "rgb(63,81,211)"
        }
    },
    hr: { color: "#bbb", backgroundColor: "#bbb", border: "#bbb" },
    tab: {
        borderRadius: 8,
        color: "grey"
    },
    table: {
        border: "1px solid #cccccc",
        borderRadius: 4,
        width: "80%",
        margin: 6
    }
});

class JobPackProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            selectedProfile: false,
            profile: [],
            oldProfile: [],
            alertOpen: false,
            uuid: [],
            tabIndex: 0,
            spacing: 16,
            openRemove: false
        };
        this.props.getAllUsers();
        if (props.match.params.jobpack_uid !== undefined)
            props.getJobPack(props.match.params.jobpack_uid);
        props.getReportTitles();

        Geocode.setApiKey("AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU");
    }
    componentDidMount() {
        loadCSS(
            "https://use.fontawesome.com/releases/v5.1.0/css/all.css",
            document.querySelector("#insertion-point-jss")
        );
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.profile !== prevProps.job_pack) {
            this.setState({
                profile: this.props.job_pack
            });

            if (
                typeof this.state.profile["attached_files"] !== "undefined" ||
                this.state.profile["attached_files"] !== []
            )
                this.props.setUploadedFiles(this.state.profile["attached_files"]);
        }
    }
    handleRemoveClickOpen = event => {
        event.preventDefault();
        this.setState({ openRemove: true });
    };

    handleRemoveClose = () => {
        this.setState({
            openRemove: false
        });
    };
    handleClickOpen = event => {
        event.preventDefault();
        this.setState({ alertOpen: true });
    };

    handleClose = () => {
        this.setState({
            alertOpen: false
        });
    };
    isActiveTab = id => {
        const { tabIndex } = this.state;
        return tabIndex === id;
    };
    goToLink = url => this.props.gotolink(url);
    onFormSubmit = () => {
        const { profile } = this.state;
        //  job_pack["timestamps"] = new Date();
        if (
            typeof profile["location_lat"] !== "string" ||
            typeof profile["location_long"] !== "string"
        ) {
            profile["location_lat"] = profile["location_lat"].toString();
            profile["location_long"] = profile["location_long"].toString();
        }
        if (typeof profile["assigned_operatives"] !== "string")
            profile["assigned_operatives"] = profile["assigned_operatives"].toString();
        if (typeof this.props.uploadedFiles !== "undefined")
            profile["attached_files"] = this.props.uploadedFiles;
        //   profile["start_date"]=this.formatDate("start_date");
        //   profile["end_date"]=this.formatDate("end_date");
        this.setState({ profile });

        this.props.postEditedJobPack(this.state.profile.profile, this.state.profile.profile.job_id);
        this.handleClose();
    };
    renderTextDetail(label, key) {
        const { profile } = this.state;
        const { classes } = this.props;
        return (
            <TextField
                key={key}
                value={profile[key]}
                label={label}
                className={classes.textField}
                onChange={val => {
                    profile[key] = val.target.value;
                    this.setState({ profile });
                }}
            />
        );
    }
    formatDate(key) {
        let DT = this.state.profile[key].split("-");

        return `${DT[2]}-${DT[1]}-${DT[0]}`;
    }
    renderImgDetail(key, valid, date) {
        const { profile } = this.state;
        const { classes } = this.props;
        let img = "./defaultImg.png";
        if (profile[key] !== "default" && profile[key] !== "" && key !== "") img = profile[key];

        return (
            <Grid item classes={classes.profileTabinnerItem} xs={6} md={4} lg={4}>
                <Card className={classes.card}>
                    <CardMedia className={classes.media} image={img} title="" />
                    <CardContent>
                        {this.renderExpiryDetail(date)}
                        {this.renderYesNoDetail(valid)}
                    </CardContent>
                    {/* <CardActions>
                    <Button size="small" color="primary">
                        Share
                    </Button>
                    <Button size="small" color="primary">
                        Learn More
                    </Button>
                    </CardActions> */}
                </Card>
            </Grid>
        );
    }
    renderTextAreaDetail(label, key) {
        const { profile } = this.state;
        const { classes } = this.props;

        return (
            <div>
                <TextField
                    key={key}
                    value={profile[key]}
                    label={label}
                    multiline={true}
                    rows={2}
                    rowsMax={4}
                    className={classes.textField}
                    onChange={val => {
                        profile[key] = val.target.value;
                        this.setState({ profile });
                    }}
                />
            </div>
        );
    }

    handleChangeUsername = event => this.setState({ username: event.target.value });
    handleUploadStart = e => this.setState({ isUploading: true });
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => console.error(error);
    handleFileRemove(filename, i) {
        const { profile } = this.state;
        this.props.removeFile(this.state.profile.job_name, filename, this.props.uploadedFiles, i);
        let files = profile["attached_files"];
        const index = files.indexOf(i);
        files.splice(index, 1);
        profile["attached_files"] = files;

        this.setState({ profile });
    }
    handleUploadSuccess = filename => {
        const { profile } = this.state;
        this.props.uploadFile(this.state.profile.job_name, filename);
        this.setState({ isUploading: false });
        profile["attached_files"] = this.props.uploadedFiles;
        this.setState({ profile });
    };
    renderYesNoDetail(label, key) {
        const { profile } = this.state;
        const { classes } = this.props;
        return (
            <FormControl className={classes.form}>
                <InputLabel>{label}</InputLabel>
                <Select
                    key={key}
                    value={profile[key]}
                    onChange={val => {
                        profile[key] = val.target.value;
                        this.setState({ profile });
                    }}
                >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                </Select>
            </FormControl>
        );
    }
    renderDateDetail(label, key) {
        const { profile } = this.state;
        const { classes } = this.props;
        let date = profile[key].split("-");
        let dt = `${date[2]}-${date[0]}-${date[1]}`;
        return (
            <div className={classes.form}>
                {/* <InputLabel className={classes.picker}>{label}</InputLabel>
                <p /> */}
                <TextField
                    id="date"
                    label={label}
                    type="date"
                    value={dt}
                    onChange={event => {
                        profile[key] = event.target.value;

                        this.setState({ profile });
                    }}
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            </div>
        );
    }
    renderExpiryDetail(key) {
        const { profile } = this.state;
        const { classes } = this.props;
        return (
            <div className={classes.form}>
                <InputLabel className={classes.picker}>{labels[key]}</InputLabel>
                <p />
                <DayPickerInput
                    key={key}
                    value={profile[key]}
                    onDayChange={val => {
                        profile[key] = val.toLocaleDateString();
                        this.setState({ profile });
                    }}
                />
            </div>
        );
    }
    isVerified(verified) {
        if (verified === "Yes" || verified === "yes") return true;
        else return false;
    }

    monthDiff(date) {
        const { classes } = this.props;
        date = date.split("/");
        let a = moment();

        let b = moment(date[0] + date[1] + date[2], "DDMMYYYY");

        let months = b.diff(a, "days");

        if (months < 1) return classes.bgRed;
        else if (months < 90) return classes.bgAmber;
        else return classes.bgGreen;
    }

    tableRowDetail(title, active) {
        const { profile } = this.state;
        const { classes } = this.props;

        return (
            <TableRow className={classes.row} key={title}>
                <TableCell component="th" scope="row">
                    {title}
                </TableCell>
                <TableCell
                    className={this.isVerified(profile[active]) ? classes.bgGreen : classes.bgRed}
                >
                    {profile[active]}
                </TableCell>
            </TableRow>
        );
    }
    render() {
        const { classes } = this.props;
        const { profile } = this.state;
        const titles = this.props.reportTitles === false ? [] : this.props.reportTitles;
        return (
            <div>
                <Grid container spacing={24}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Card>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="Profile-Edit" className={classes.avatar}>
                                        <AccountBox />
                                    </Avatar>
                                }
                                title={<Typography variant="headline">Jobpack Profile</Typography>}
                            />
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <Paper className={classes.paper}>
                            {this.state.profile !== false && (
                                <form onSubmit={this.handleClickOpen}>
                                    <Grid container>
                                        <Fade
                                            in={true}
                                            timeout={{
                                                enter: 400,
                                                exit: 400
                                            }}
                                        >
                                            <Grid
                                                item
                                                classes={classes.profileTabItem}
                                                xs={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <Card className={classes.tabTitle}>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar
                                                                aria-label="Profile-Edit"
                                                                className={classes.avatar}
                                                            >
                                                                <Icon
                                                                    className={classNames(
                                                                        classes.icon,
                                                                        "fas fa-user fa-1x"
                                                                    )}
                                                                />
                                                            </Avatar>
                                                        }
                                                        title={
                                                            <Typography variant="headline">
                                                                General Information
                                                            </Typography>
                                                        }
                                                    />
                                                </Card>
                                                <Grid container spacing={8}>
                                                    <Grid
                                                        item
                                                        classes={classes.profileTabinnerItem}
                                                        xs={12}
                                                        md={6}
                                                        lg={6}
                                                    >
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Job Name
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["job_name"]}{" "}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Job ID:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["job_id"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Job Type:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["job_type"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Client:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["client_name"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Address:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["address"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Assigned Supervisor:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["assigned_supervisor"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Assigned Operative:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {typeof profile[
                                                                "assigned_operatives"
                                                            ] !== "string"
                                                                ? profile["assigned_operatives"]
                                                                : profile[
                                                                      "assigned_operatives"
                                                                  ].toString()}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Assigned Manager:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["assigned_manager"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Start Date:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["start_date"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            End Date:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["end_date"]}
                                                        </Typography>
                                                        <hr className={classes.hr} />
                                                        <Typography
                                                            variant="subheading"
                                                            align="center"
                                                        >
                                                            Description:
                                                        </Typography>
                                                        <Typography variant="body1" align="center">
                                                            {profile["description_of_works"]}
                                                        </Typography>
                                                        <Typography
                                                            variant="headline"
                                                            className={classes.title}
                                                        >
                                                            Uploaded Files:
                                                        </Typography>
                                                        <div>
                                                            <List dense={false}>
                                                                {typeof this.state.profile
                                                                    .attached_files !==
                                                                    "undefined" &&
                                                                    this.state.profile.attached_files.map(
                                                                        (e, i) => {
                                                                            return (
                                                                                <ListItem
                                                                                    onClick={() => {
                                                                                        this.goToLink(
                                                                                            `/pdf-viewer/job_pack/${
                                                                                                profile.job_id
                                                                                            }/attached-files/${i}`
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <ListItemAvatar>
                                                                                        <Avatar>
                                                                                            <FolderIcon />
                                                                                        </Avatar>
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText
                                                                                        primary={
                                                                                            e.file
                                                                                        }
                                                                                    />
                                                                                </ListItem>
                                                                            );
                                                                        }
                                                                    )}
                                                            </List>
                                                        </div>
                                                    </Grid>

                                                    <Grid
                                                        item
                                                        classes={classes.profileTabinnerItem}
                                                        xs={12}
                                                        md={6}
                                                        lg={6}
                                                    >
                                                        <div
                                                            style={{
                                                                width: "90%",
                                                                minHeight: 250
                                                            }}
                                                        >
                                                            <MapContainer
                                                                lat={profile["location_lat"]}
                                                                long={profile["location_long"]}
                                                                action={
                                                                    (this.onMapClick = (
                                                                        e,
                                                                        t,
                                                                        v
                                                                    ) => {
                                                                        //do something
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                        <Table className={classes.table}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Form</TableCell>
                                                                    <TableCell>Active</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {titles &&
                                                                    Object.keys(titles).map(
                                                                        (e, i) => {
                                                                            return this.tableRowDetail(
                                                                                titles[e],
                                                                                e
                                                                            );
                                                                        }
                                                                    )}
                                                            </TableBody>
                                                        </Table>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Fade>
                                    </Grid>
                                </form>
                            )}
                            {this.state.profile === false && (
                                <div>
                                    <CircularProgress className={classes.progress} />
                                </div>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

JobPackProfile.propTypes = {
    classes: PropTypes.object.isRequired
};

export default connect(
    store => {
        return {
            reportTitles: selectReportTitles(store),
            job_pack: selectJobPack(store),
            users: selectAllUsers(store),
            uploadedFiles: selectUploadedFiles(store)
        };
    },
    {
        getJobPack,
        setSelectedTab,
        setSelectedJobPackIndex,
        postEditedJobPack,
        removeJobPack,
        getReportTitles,
        getAllUsers,
        gotolink,
        uploadFile,
        removeFile,
        setUploadedFiles
    }
)(withStyles(styles)(JobPackProfile));
